import React from 'react';

import RequestTable from '@buyside/components/presentation/UserAccount/ViewerIntroRequests/Table/userViewerIntroRequestTable';

import styles from './styles.scss';

const UserViewerIntroRequestsPage: React.FC = () => {
  return (
    <>
      <h1 className={styles.pageTitle}>Received Intro Requests</h1>
      <RequestTable />
    </>
  );
};

export default UserViewerIntroRequestsPage;
